// @ts-nocheck
import React from 'react'
import moment from 'moment'
import { t } from 'ttag'
import { Box } from 'components/layout/Box/Box'
import { Table } from 'components/shared/Table/Table'

import styles from './DateCell.module.scss'

export const DateCell = ({
  date,
  label,
  hasIncreasedHeight,
  hasNowLabel = false,
  align = 'center',
}) => {
  const isDateOnly = moment(date)._f === 'YYYY-MM-DD'
  const isToday = moment(date).isSame(new Date(), 'day')

  const formattedDate = date ? moment(date).format('YYYY-MM-DD') : '-'
  const nowLabel = label
    ? label
    : isDateOnly && isToday
    ? t`today`
    : moment(date).fromNow()

  return (
    <Table.Cell type="body" {...{ hasIncreasedHeight }}>
      <Box
        align={align}
        className={styles.content}
        direction="column"
        tagName="span"
      >
        <span className={styles.date}>{formattedDate}</span>
        {hasNowLabel && <span className={styles.label}>{nowLabel}</span>}
      </Box>
    </Table.Cell>
  )
}
